import React, { useEffect, useState } from 'react';
import styled from 'styled-components';
import {colors} from '../../styles/colors';
import { Link } from 'react-scroll';
//import { Privacy } from './main/Privacy';
//import { Route } from "react-router-dom";
import Popup from 'reactjs-popup';
import 'reactjs-popup/dist/index.css';
import {  BrowserRouter as Router, useNavigate, Switch,  Route,  Link as Linkk} from "react-router-dom";
import './scrollbar.css';


const NavContainer = styled.nav`
  width: 100vw;
  height: 70px;
  font:   normal 17px/150% Tahoma;
  box-sizing: border-box;
  background-color: ${colors.navbarBackground};
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 4 64px;
  align-items: center;
  position: fixed;
  top: 0;
  left: 50;
  z-index: 10;
`;

const LeftPanel = styled.div`
  width: 100px;
  color: ${colors.logo};
  font-size: 2.0em;
  font-weight: normal;
  margin-left: 155px;
`;

const RightPanel = styled.div`
  flex-grow: 1
  background-color: blue;
`;

const MenuItems = styled.ul`
  list-style-type: none;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
`;

const MenuItem = styled.li`
  margin-right: 52px;
  box-sizing: border-box;
  cursor: pointer;
  & :hover {
    font-weight: normal;
    color: #a5a5a5;
      }
  
  & > a {
    text-decoration: none;
    color: ${colors.menuLink};
  }
  
`;

const HomeContainer = styled.div`
  width: 100vw;
  height: 100%;
  box-sizing: border-box;
  background-color: ${colors.homeBackground};
  display: flex;
  flex-direction: column;
  padding: 0 24px;
  align-items: center;
  overflow: hidden;
  margin-bottom: 100px;
  
`;

function Privacy() {
  
  const [open, setOpen] = useState(true);
  //const closeModal = () => setOpen(false);
  
  return (
    
        <Popup open={open} closeOnDocumentClick ={false} lockScroll={true} defaultOpen= {false} closeOnEscape = {false} repositionOnResize = {true}>
            {
                close => (
              
                  <div>
                        <div class="scrollable-div">
                        <h1>Privacy Policy</h1>
<p>Last updated: August 12, 2024</p>
<p>This Privacy Policy describes Our policies and procedures on the collection, use and disclosure of Your information when You use the Service and tells You about Your privacy rights and how the law protects You.</p>
<p>We use Your Personal data to provide and improve the Service. By using the Service, You agree to the collection and use of information in accordance with this Privacy Policy.</p>
<p>Paper Pixel Studios (collectively, “us”, “our” or “we”) provides this Privacy Policy to describe the types of information we collect online and the ways we collect, store, use, and manage these information, including personal information, and data that our users (“users”, “your” or “you”) provide or we may collect in connection with your activity on the Paper Pixel Studios website available at https://paperpixelstudios.com/ and any Paper Pixel Studios provided on a mobile platform (each a “Service,” collectively, the “Services”).</p>
<h2>Collecting and Using Your Personal Data</h2>
<h3>Types of Data Collected</h3>
<h4>Personal Data</h4>
<p>While using Our Service, We may ask You to provide Us with certain personally identifiable information that can be used to contact or identify You. Personally identifiable information may include, but is not limited to:</p>
<ul>
<li>
<p>Email address</p>
</li>
<li>
<p>First name and last name</p>
</li>
<li>
<p>Phone number</p>
</li>
<li>
<p>Usage Data</p>
</li>
</ul>
<h4>Usage Data</h4>
<p>Usage Data may include information such as Your Device's Internet Protocol address (e.g. IP address), browser type, browser version, the pages of our Service that You visit, the time and date of Your visit, the time spent on those pages, unique device identifiers and other diagnostic data.</p>
<p>When You access the Service by or through a mobile device, We may collect certain information automatically, including, but not limited to, the type of mobile device You use, Your mobile device unique ID, the IP address of Your mobile device, Your mobile operating system, the type of mobile Internet browser You use, unique device identifiers and other diagnostic data.</p>
<p>We may also collect information that Your browser sends whenever You visit our Service or when You access the Service by or through a mobile device.</p>
<h4>Information from Third-Party Social Media Services</h4>
<p>The Company allows You to create an account and log in to use the Service through the following Third-party Social Media Services:</p>
<ul>
<li>Google</li>
<li>Facebook</li>
<li>Instagram</li>
<li>Twitter</li>
<li>LinkedIn</li>
</ul>
<p>If You decide to register through or otherwise grant us access to a Third-Party Social Media Service, We may collect Personal data that is already associated with Your Third-Party Social Media Service's account, such as Your name, Your email address, Your activities or Your contact list associated with that account.</p>
<p>You may also have the option of sharing additional information with the Company through Your Third-Party Social Media Service's account. If You choose to provide such information and Personal Data, during registration or otherwise, You are giving the Company permission to use, share, and store it in a manner consistent with this Privacy Policy.</p>
<h4>Tracking Technologies and Cookies</h4>
<p>We may use Cookies and similar tracking technologies to track the activity on Our Service and store certain information. Tracking technologies used are beacons, tags, and scripts to collect and track information and to improve and analyze Our Service. The technologies We use may include:</p>
<ul>
<li><strong>Cookies or Browser Cookies.</strong> A cookie is a small file placed on Your Device. You can instruct Your browser to refuse all Cookies or to indicate when a Cookie is being sent. However, if You do not accept Cookies, You may not be able to use some parts of our Service. Unless you have adjusted Your browser setting so that it will refuse Cookies, our Service may use Cookies.</li>
</ul>
<h3>Use of Your Personal Data</h3>
<p>The Company may use Personal Data for the following purposes:</p>
<ul>
<li>
<p><strong>To provide and maintain our Service</strong>, including to monitor the usage of our Service.</p>
</li>
<li>
<p><strong>For the performance of a contract:</strong> the development, compliance and undertaking of the purchase contract for the products, items or services You have purchased or of any other contract with Us through the Service.</p>
</li>
<li>
<p><strong>To contact You:</strong> To contact You by email, telephone calls, SMS, or other equivalent forms of electronic communication, such as a mobile application's push notifications regarding updates or informative communications related to the functionalities, products or contracted services, including the security updates, when necessary or reasonable for their implementation.</p>
</li>
<li>
<p><strong>For other purposes</strong>: We may use Your information for other purposes, such as data analysis, identifying usage trends, determining the effectiveness of our promotional campaigns and to evaluate and improve our Service, products, services, marketing and your experience.</p>
</li>
</ul>
<p>We may share Your personal information in the following situations:</p>
<ul>
<li><strong>With Service Providers:</strong> We may share Your personal information with Service Providers to monitor and analyze the use of our Service,  to contact You.</li>
<li><strong>With Your consent</strong>: We may disclose Your personal information for any other purpose with Your consent.</li>
</ul>
<h3>Retention of Your Personal Data</h3>
<p>The Company will retain Your Personal Data only for as long as is necessary for the purposes set out in this Privacy Policy. We will retain and use Your Personal Data to the extent necessary to comply with our legal obligations (for example, if we are required to retain your data to comply with applicable laws), resolve disputes, and enforce our legal agreements and policies.</p>
<p>The Company will also retain Usage Data for internal analysis purposes. Usage Data is generally retained for a shorter period of time, except when this data is used to strengthen the security or to improve the functionality of Our Service, or We are legally obligated to retain this data for longer time periods.</p>
<h3>Transfer of Your Personal Data</h3>
<p>Your information, including Personal Data, is processed at the Company's operating offices and in any other places where the parties involved in the processing are located. It means that this information may be transferred to — and maintained on — computers located outside of Your state, province, country or other governmental jurisdiction where the data protection laws may differ than those from Your jurisdiction.</p>
<p>Your consent to this Privacy Policy followed by Your submission of such information represents Your agreement to that transfer.</p>
<p>The Company will take all steps reasonably necessary to ensure that Your data is treated securely and in accordance with this Privacy Policy and no transfer of Your Personal Data will take place to an organization or a country unless there are adequate controls in place including the security of Your data and other personal information.</p>
<h3>In-game Advertising</h3>
<p>Our games may serve ads. These ads enable us to offer free-to-play games.</p>
<p>By accepting this Privacy Policy and downloading or continuing to play our games, you consent to us and advertising business collecting and using information about you to improve advertising, targeting and measurement systems so that we can show you relevant third-party ads in our games.</p>
<p>For in-game advertising uses multiple mediation service that enables third-party advertising networks to optimize placements of ads, buy ad inventory and serve ads in our games.</p>
<p>These platforms collect data such as device type, country, device language, in-game behavior and purchases, IP address.</p>
<h3>Delete Your Personal Data</h3>
<p>You have the right to delete or request that We assist in deleting the Personal Data that We have collected about You.</p>
<p>Our Service may give You the ability to delete certain information about You from within the Service.</p>
<p>You may update, amend, or delete Your information at any time by signing in to Your Account, if you have one, and visiting the account settings section that allows you to manage Your personal information. You may also contact Us to request access to, correct, or delete any personal information that You have provided to Us.</p>
<p>Please note, however, that We may need to retain certain information when we have a legal obligation or lawful basis to do so.</p>
<h3>Disclosure of Your Personal Data</h3>

<p>We may share your information with third-party business who assist in delivering and optimizing our games and websites. Where we may share your information with third-party service providers and business.</p>
<h4>Law enforcement</h4>
<p>Under certain circumstances, the Company may be required to disclose Your Personal Data if required to do so by law or in response to valid requests by public authorities (e.g. a court or a government agency).</p>
<h4>Other legal requirements</h4>
<p>The Company may disclose Your Personal Data in the good faith belief that such action is necessary to:</p>
<ul>
<li>Comply with a legal obligation</li>
<li>Protect and defend the rights or property of the Company</li>
<li>Prevent or investigate possible wrongdoing in connection with the Service</li>
<li>Protect the personal safety of Users of the Service or the public</li>
<li>Protect against legal liability</li>
</ul>
<h3>Security of Your Personal Data</h3>
<p>The security of Your Personal Data is important to Us, but remember that no method of transmission over the Internet, or method of electronic storage is 100% secure. While We strive to use commercially acceptable means to protect Your Personal Data, We cannot guarantee its absolute security.</p>
<h2>Children's Privacy</h2>
<p>Our Service does not address anyone under the age of 13. We do not knowingly collect personally identifiable information from anyone under the age of 13. If You are a parent or guardian and You are aware that Your child has provided Us with Personal Data, please contact Us. If We become aware that We have collected Personal Data from anyone under the age of 13 without verification of parental consent, We take steps to remove that information from Our servers.</p>
<p>If We need to rely on consent as a legal basis for processing Your information and Your country requires consent from a parent, We may require Your parent's consent before We collect and use that information.</p>
<h2>Links to Other Websites</h2>
<p>Our Service may contain links to other websites that are not operated by Us. If You click on a third party link, You will be directed to that third party's site. We strongly advise You to review the Privacy Policy of every site You visit.</p>
<p>We have no control over and assume no responsibility for the content, privacy policies or practices of any third party sites or services.</p>
<h2>Changes to this Privacy Policy</h2>
<p>We may update Our Privacy Policy from time to time.</p>
<p>We will let You know via email and/or a prominent notice on Our Service, prior to the change becoming effective and update the &quot;Last updated&quot; date at the top of this Privacy Policy.</p>
<p>You are advised to review this Privacy Policy periodically for any changes. Changes to this Privacy Policy are effective when they are posted on this page.</p>
<h2>Contact Us</h2>
<p>If you have any questions about this Privacy Policy, You can contact us:</p>
<ul>
<li>
<p>By email: paperpixelstd@gmail.com</p>
</li>
<li>
<p>By visiting this page.</p>
</li>
</ul> 
<ul></ul>
                        <div>
                            <button class = "button" onClick={() => {console.log('modal closed '); close(); window.history.replaceState({}, "", "/"); window.location.reload();}}>Close</button>
                        </div>
                    </div>
                    </div>
                )
            }
        </Popup>
    
)
//<div style="overflow-y:scroll; height:400px; background:gray">
};


const NavBar = () => {
  return (
    <Router>
    <NavContainer>
      <LeftPanel><nobr>Paper Pixel  <small><small>Studios</small></small></nobr></LeftPanel>
      <RightPanel>
        <MenuItems>
          <MenuItem><Link activeClass="active" to="section-main" spy={true} smooth={true} duration={1000}>Games</Link></MenuItem>
          <MenuItem><Link activeClass="active" to="section-about" spy={true} smooth={true} duration={1000}>About</Link></MenuItem>
          <MenuItem><Link activeClass="active" to="section-contactus" spy={true} smooth={true} duration={1000}>Contact</Link></MenuItem>
          <MenuItem><Linkk to="/privacy">Privacy</Linkk></MenuItem>
          <Switch>
          <Route path="/privacy">{<Privacy/>}</Route>
          </Switch>
        </MenuItems>
      </RightPanel>
    </NavContainer>
    </Router>
  )
}

export default NavBar;